import { Toaster } from 'sonner';
import { useTheme } from './useTheme';

/** Toasts are rendered outside the page, so they need the theme handed to them. */
export const ThemedToaster = () => {
  const { resolved } = useTheme();
  return <Toaster position="bottom-right" theme={resolved} richColors closeButton />;
};
